import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useSystemMessage } from '../contexts/SystemMessageContext';

function AuthBridgePage() {
	const location = useLocation();
	const navigate = useNavigate();
	const { type: typeFromPath } = useParams();
	const { showMessage } = useSystemMessage();

	const defaultMessage = '인가되지 않은 시스템 사용은 금지되며 민·형사상의 처벌 대상입니다.';

	useEffect(() => {
		const params = new URLSearchParams(location.search);
		const token = params.get('token');

		if (!token) return;

		const type = params.get('type') || typeFromPath || 'dtx001';
		const alertCode = params.get('alertCode') || '';
		const displayName = params.get('displayName') || 'admin';

		const payload = {
			accessToken: token,
			// refreshToken이 없으면 accessToken을 그대로 넣어 401/refresh 흐름에서 제거되지 않도록 방어
			refreshToken: params.get('refreshToken') || token,
			expiresIn: params.get('expiresIn') || 3600,
			refreshExpiresIn: params.get('refreshExpiresIn') || 604800,
			displayName,
			alertCode,
		};

		// 1. 토큰 및 세션 정보 저장
		localStorage.setItem(`${type}token`, JSON.stringify(payload));

		// 2. 로그인 토스트 메시지 표시
		const hasShownToast = sessionStorage.getItem('hasShownLoginToast');
		if (!hasShownToast) {
			showMessage(defaultMessage, 2000);
			sessionStorage.setItem('hasShownLoginToast', 'true');
		}

		// 3. 임시 비밀번호 체크 -> 변경 페이지로 이동
		if (alertCode === 'Initial-Password-Change-Required') {
			if (type !== 'dtx006') alert('초기 비밀번호를 변경해 주십시오.');
			navigate(`/change-pw/${type}/initial`, { replace: true });
			return;
		}

		// 4. 서비스별 대시보드로 이동
		if (type === 'dtx001') {
			navigate('/dtx001/dashboard', { replace: true });
		} else if (type === 'dtx002') {
			navigate('/dtx002/patient-manage/list', { replace: true });
		} else if (type === 'dtx006') {
			navigate('/dtx006/dashboard', { replace: true });
		} else {
			navigate('/dtx001/dashboard', { replace: true });
		}
	}, [location.search, navigate, typeFromPath, showMessage]);


	return (
		<div
			style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}
		>
			<span>인증 처리 중입니다...</span>
		</div>
	);
}

export default AuthBridgePage;
